import { X } from "lucide-react";

const AlertsModal = ({ isOpen, setIsOpen, details }) => {
  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <div className="relative">
      {isOpen && (
        <div
          className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50"
          onClick={handleClose} // Close modal when clicking on overlay
        >
          <div
            className="bg-white rounded-lg shadow-lg p-6 overflow-y-auto  xl:w-[40%] lg:w-[45%] md:w-[60%] w-[90%]"
            onClick={(e) => e.stopPropagation()} // Prevent close when clicking inside the modal
          >
            <div className="flex justify-between mb-3 items-center">
              <h2 className="text-xl capitalize font-bold text-darkBlue">
                Vulnerability Details
              </h2>

              <X className="cursor-pointer " onClick={handleClose} size={20} />
            </div>
            <hr />
            <div className="flex flex-col gap-2 my-4">
              <p>
                <span className="font-medium mr-1">Name:</span>
                {details.name ?? "-"}
              </p>
              <p>
                <span className="font-medium mr-1">Severity:</span>
                {details.riskAsFloat ?? "-"}
              </p>

              <p>
                <span className="font-medium mr-1">Confidence:</span>
                {details.confidence ?? "-"}
              </p>
              <p>
                <span className="font-medium mr-1">CWE ID:</span>
                {details.cweid ?? "-"}
              </p>
              <p className="break-all">
                <span className="font-medium mr-1">Description:</span>
                {details.description ?? "-"}
              </p>
              <p className="break-all">
                <span className="font-medium mr-1">Solution:</span>
                {details.solution ?? "-"}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AlertsModal;
